import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: size is 24x14. Be careful with
// how / where this is used to ensure it renders as expected.
export const TwoPeople: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG viewBox="0 0 24 14" {...props}>
            <IconPath
                d="M11.69 11.265c1.316-1.395 3.102-2.253 5.07-2.253 1.966 0 3.753.858 5.068 2.253m-2.534-7.04a2.535 2.535 0 1 1-5.07 0 2.535 2.535 0 0 1 5.07 0Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                {...pathProps}
            />
            <IconPath d="M8.5 8.498c.667-.167 2.7.3 5.5 3.5" stroke="#fff" />
            <IconPath
                d="M1.69 11.265C3.006 9.87 4.792 9.012 6.76 9.012c1.966 0 3.753.858 5.068 2.253m-2.534-7.04a2.535 2.535 0 1 1-5.07 0 2.535 2.535 0 0 1 5.07 0Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                {...pathProps}
            />
        </IconSVG>
    );
};
